<div class="row bg-grey-100 m-0 flex-grow-1">
  <div class="col-md-6 p-0 bg-white">
    <div class="main-padding pt-5">
      <div class="mt-4 mb-4">
        <app-back-to-event [event_id]="event?.event_id"></app-back-to-event>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="col-md-6 p-0">
    <div class="">
      <app-event [minified]="true" [event]="event"></app-event>
    </div>
    <div class="mb-3">
      <app-order-summary
        [orderSummary]="orderSummary$ | ngrxPush"
      ></app-order-summary>
    </div>
  </div>
</div>
